async function loadIcons() {
  const { library, dom } = await import("@fortawesome/fontawesome-svg-core")

  const {
    faAngleLeft,
    faAngleRight,
    faArrowUpRightFromSquare,
    faAward,
    faBars,
    faBath,
    faBatteryFull,
    faBatteryThreeQuarters,
    faBell,
    faBlind,
    faBoxOpen,
    faBroadcastTower,
    faBullhorn,
    faBullseye,
    faCalendar,
    faCalendarCheck,
    faCalendarDays,
    faCaretLeft,
    faCaretRight,
    faCartPlus,
    faCartShopping,
    faCheck,
    faCircle,
    faCircleXmark,
    faClipboardList,
    faClock,
    faCommentDots,
    faCompass,
    faCompress,
    faDesktop,
    faDollarSign,
    faDolly,
    faDownload,
    faDroplet,
    faEdit,
    faEnvelope,
    faExclamationCircle,
    faFeather,
    faFileArrowDown,
    faFingerprint,
    faFireExtinguisher,
    faHeart,
    faLock,
    faMagnifyingGlass,
    faMapLocationDot,
    faMapMarked,
    faMapMarker,
    faMapMarkerAlt,
    faMedkit,
    faMobileAlt,
    faMobileScreen,
    faMoneyBill,
    faMoneyBillAlt,
    faPersonFalling,
    faPhone,
    faPhoneVolume,
    faReplyAll,
    faShareSquare,
    faShield,
    faShippingFast,
    faShoePrints,
    faShoppingCart,
    faSignLanguage,
    faSquare,
    faSuitcaseMedical,
    faSun,
    faThermometerHalf,
    faTimes,
    faTint,
    faTowerBroadcast,
    faTrophy,
    faTruck,
    faTruckMedical,
    faUnlock,
    faUser,
    faUserFriends,
    faVolumeHigh,
    faWalking,
    faWifi,
    faXmark,
  } = await import("@fortawesome/free-solid-svg-icons")

  const { faFacebookF, faLinkedinIn, faTwitter, faYoutube } = await import(
    "@fortawesome/free-brands-svg-icons"
  )

  library.add(
    // solid
    faAngleLeft,
    faAngleRight,
    faArrowUpRightFromSquare,
    faAward,
    faBars,
    faBath,
    faBatteryFull,
    faBatteryThreeQuarters,
    faBell,
    faBlind,
    faBoxOpen,
    faBroadcastTower,
    faBullhorn,
    faBullseye,
    faCalendar,
    faCalendarCheck,
    faCalendarDays,
    faCaretLeft,
    faCaretRight,
    faCartPlus,
    faCartShopping,
    faCheck,
    faCircle,
    faCircleXmark,
    faClipboardList,
    faClock,
    faCommentDots,
    faCompass,
    faCompress,
    faDesktop,
    faDollarSign,
    faDolly,
    faDownload,
    faDroplet,
    faEdit,
    faEnvelope,
    faExclamationCircle,
    faFeather,
    faFileArrowDown,
    faFingerprint,
    faFireExtinguisher,
    faHeart,
    faLock,
    faMagnifyingGlass,
    faMapLocationDot,
    faMapMarked,
    faMapMarker,
    faMapMarkerAlt,
    faMedkit,
    faMobileAlt,
    faMobileScreen,
    faMoneyBill,
    faMoneyBillAlt,
    faPersonFalling,
    faPhone,
    faPhoneVolume,
    faReplyAll,
    faShareSquare,
    faShield,
    faShippingFast,
    faShoePrints,
    faShoppingCart,
    faSignLanguage,
    faSquare,
    faSuitcaseMedical,
    faSun,
    faThermometerHalf,
    faTimes,
    faTint,
    faTowerBroadcast,
    faTrophy,
    faTruck,
    faTruckMedical,
    faUnlock,
    faUser,
    faUserFriends,
    faVolumeHigh,
    faWalking,
    faWifi,
    faXmark,
    // brands
    faFacebookF,
    faLinkedinIn,
    faTwitter,
    faYoutube,
  )

  dom.watch()
}

// Call the function to load icons
loadIcons()
